module.exports = __webpack_public_path__ + "img/sweden-stomach-cancer-female.70a0ae4f.png";